export default "__VITE_ASSET__CIqL3zHt__"